<template>
  <v-content class="pa-0 ma-0">
    <v-data-table
      v-if="comments != null"
      :items="comments"
      :headers="headers"
      disable-initial-sort
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr :key="props.index">
          <td
            class="text-xs-left"
            style="cursor: pointer"
            @click="viewClient(props.item.company_id)"
          >
            {{ props.item.company_name_with_user }}
          </td>
          <td class="text-xs-left">
            {{ props.item.text }}
          </td>
          <td
            class="text-xs-left"
            style="cursor: pointer"
            @click="openQuestionnaire(props.item)"
          >
            {{ props.item.questionnaire_name }}
          </td>
          <td class="text-xs-left">
            {{ moment(props.item.created_at).format('lll') }}
          </td>
        </tr>
      </template>

      <template slot="no-data">
        <v-layout class="text-xs-center grey--text">
          <v-flex>
            <v-icon size="16" color="grey"> priority_high </v-icon>
            <span class="ml-1">None</span>
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-content>
</template>

<script>
import moment from 'moment';

export default {
  name: 'QuestionnaireCommentsTable',
  props: {
    comments: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      moment,
      headers: [
        {
          text: 'Entity (Click for dashboard)',
          align: 'left',
          sortable: true,
          value: 'company_name_with_user',
          width: '20%',
        },
        {
          text: 'Note',
          align: 'left',
          sortable: true,
          value: 'text',
          width: '40%',
        },
        {
          text: 'Questionnaire name (Click to open)',
          align: 'left',
          sortable: true,
          value: 'questionnaire_name',
          width: '20%',
        },
        {
          text: 'Created at',
          align: 'left',
          value: 'created_at',
          sortable: true,
          width: '20%',
        },
      ],
    };
  },
  methods: {
    viewClient(companyId) {
      window.open(`/admin-dashboard?companyId=${companyId}`, '_blank');
    },
    openQuestionnaire(comment) {
      window.open(
        `/admin-dashboard?companyId=${comment.company_id}&questionnaireId=${comment.questionnaire_id}`,
        '_blank',
      );
    },
  },
};
</script>
